// url has type

import { FileAttachment, FileAttachmentV2 } from 'api/attachments';
import { ProjectFileGroup } from 'api/project-files/types';

// spotlight, recents, project_files, general_shared_files or a folderId
export type UrlType =
  | 'spotlight'
  | 'recents'
  | 'project_files'
  | 'general_shared_files'
  | number;

export const SPOTLIGHT_FOLDER_ID = -1;
export const RECENTS_FOLDER_ID = -2;
export const GENERAL_SHARED_FILES_FOLDER_ID = -3;
export const PROJECT_FILES_FOLDER_ID = -4;

export enum ListOrGridMode {
  List,
  Grid,
}

export interface CpAllFilesData extends Record<string, unknown> {
  title: string;
  description: string;
  spotlightedAttachments: FileAttachment[];
  attachmentsInProject: FileAttachmentV2[];
  recents: FileAttachmentV2[];
  generalSharedAttachments: FileAttachment[];
  folders: ProjectFileGroup[];
}

export interface CpAllFilesProps {
  search: string;
  currentFolder: ProjectFileGroup | undefined;
  onFolderClick: (folderId: UrlType | undefined) => void;
  data: CpAllFilesData;
  mode: ListOrGridMode;
  setMode: (mode: ListOrGridMode) => void;
  currentAttachments: (FileAttachment | FileAttachmentV2)[];
  handleDownload: (attachmentId: number) => void;
  onFileClick: (attachmentId: number) => void;
  projectId: number;
  refetch: VoidFunction;
}
